export default "__VITE_ASSET__Lld45oP1__"